import React from "react";

const SingleLineSkeleton = ({
  width = "100%",
  height = "1em",
  className = "",
}) => (
  <div
    className={`bg-gray-200 dark:bg-gray-700 rounded animate-pulse ${className}`}
    style={{ width, height }}
  />
);

export default SingleLineSkeleton;

// Add this to your global CSS or in a CSS-in-JS solution
// @keyframes skeleton-loading {
//   0% { background-position: -200px 0; }
//   100% { background-position: calc(200px + 100%) 0; }
// }
